import { Inbox, SearchX } from 'lucide-react';

import { DataTable } from '@/components/ui/data-table';
import { EmptyState } from '@/components/ui/empty-state';
import { Spinner } from '@/components/ui/spinner';
import type { Columns, Filters } from '@/types/table';

import { ImportHistoryCard } from './ImportHistoryCard';

interface ImportHistoryTableProps {
  loading: boolean;
  columns: Columns[];
  tableData: Record<string, unknown>[];
  filters: Filters[];
}

export function ImportHistoryTable({
  loading,
  columns,
  tableData,
  filters,
}: ImportHistoryTableProps) {
  return (
    // max-lg:-mx-4 cancels DataTable's built-in 16px card-list gutter (its
    // <ul> p-4, sized for unpadded hosts like the orders list) against this
    // page's padded section, so cards align with the filters above them
    // instead of sitting doubly inset.
    <section className="flex min-h-0 flex-1 flex-col max-lg:-mx-4" aria-label="import-history">
      {loading ? (
        <div className="flex flex-1 items-center justify-center py-12">
          <Spinner size="default" aria-label="history-table-spinner" />
        </div>
      ) : (
        <DataTable
          columns={columns}
          tableData={tableData}
          filters={filters}
          isLoading={false}
          showCheckboxes={false}
          hideActionBar={true}
          renderMobileCard={(row) => <ImportHistoryCard row={row} />}
          emptyState={
            <EmptyState
              icon={Inbox}
              title="No Files Uploaded Yet"
              description="Once you upload a file, your import history will appear here."
            />
          }
          noResultsState={
            <EmptyState
              icon={SearchX}
              title="No Imports Match Your Filters"
              description="Try adjusting your search or filters."
            />
          }
        />
      )}
    </section>
  );
}
